<template>
  <div>
    <Pos_promotion_create_new/>
  </div>
</template>

<script>
import Pos_promotion_create_new from "@/components/adminArin/pos_system/warehouse/inventory/Pos_promotion_create_new";
export default {
  name: "PosPromotionCreateNew",
  components: {
    Pos_promotion_create_new
  }
}
</script>

<style scoped>

</style>
